import SidebarHead from './SidebarHead';

export default SidebarHead;
